import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getMyPermission = createAsyncThunk('profile/getMyPermission',
  async (id, { rejectWithValue }) => {
    try {
      const { data: { role_permission: permissions } = {} } = await authGet(`/roles/${id}`);
      return permissions;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getMyPermission;
